import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useTheme } from 'emotion-theming';
import { makeImgResizerUrl } from '@jelly/utils';
import { SiteConfigContext } from '../SiteConfigProvider';
export function MetaData(_ref) {
  var _ref$meta = _ref.meta,
      canonical = _ref$meta.canonical,
      description = _ref$meta.description,
      ogImage = _ref$meta.ogImage,
      robots = _ref$meta.robots,
      title = _ref$meta.title;

  var _useContext = useContext(SiteConfigContext),
      _useContext$siteConst = _useContext.siteConstants,
      META_DATA = _useContext$siteConst.META_DATA,
      SITE_HOST = _useContext$siteConst.SITE_HOST;

  var _useTheme = useTheme(),
      primary = _useTheme.colors.primary;

  var applicationName = META_DATA.applicationName;
  var twitterName = META_DATA.twitterName;
  canonical = canonical || SITE_HOST;
  description = description || META_DATA.description;
  robots = robots || META_DATA.robots;
  title = title || META_DATA.title;
  var resizedImage = makeImgResizerUrl({
    src: ogImage ? ogImage : META_DATA.ogImage,
    method: 'w',
    w: '700'
  });
  return /*#__PURE__*/React.createElement(Helmet, {
    htmlAttributes: {
      lang: 'en'
    }
  }, /*#__PURE__*/React.createElement("meta", {
    charset: "utf-8"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "viewport",
    content: "width=device-width, initial-scale=1, shrink-to-fit=no"
  }), /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("meta", {
    "http-equiv": "Content-Type",
    content: "text/html; charset=utf-8"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "title",
    content: title
  }), /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: description
  }), robots && /*#__PURE__*/React.createElement("meta", {
    name: "robots",
    content: robots
  }), /*#__PURE__*/React.createElement("meta", {
    name: "mobile-web-app-capable",
    content: "yes"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "apple-mobile-web-app-capable",
    content: "yes"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "application-name",
    content: applicationName
  }), /*#__PURE__*/React.createElement("meta", {
    name: "apple-mobile-web-app-title",
    content: applicationName
  }), /*#__PURE__*/React.createElement("meta", {
    name: "theme-color",
    content: primary
  }), /*#__PURE__*/React.createElement("meta", {
    name: "msapplication-navbutton-color",
    content: primary
  }), /*#__PURE__*/React.createElement("meta", {
    name: "apple-mobile-web-app-status-bar-style",
    content: "black-translucent"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "msapplication-starturl",
    content: "/"
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:title",
    content: title
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:description",
    content: description
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:site_name",
    content: applicationName
  }), canonical && /*#__PURE__*/React.createElement("meta", {
    property: "og:url",
    content: canonical
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:image",
    content: resizedImage
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:type",
    content: "article"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "twitter:card",
    content: "summary"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "twitter:site",
    content: twitterName
  }), /*#__PURE__*/React.createElement("meta", {
    name: "twitter:creator",
    content: twitterName
  }), /*#__PURE__*/React.createElement("meta", {
    name: "twitter:title",
    content: title
  }), /*#__PURE__*/React.createElement("meta", {
    name: "twitter:description",
    content: description
  }), /*#__PURE__*/React.createElement("meta", {
    name: "twitter:image",
    content: resizedImage
  }), canonical && /*#__PURE__*/React.createElement("link", {
    rel: "canonical",
    href: canonical
  }), /*#__PURE__*/React.createElement("link", {
    rel: "manifest",
    href: "/manifest.webmanifest"
  }));
}